import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

export default function OfflineBanner() {
  const [offline, setOffline] = useState(typeof navigator !== "undefined" && !navigator.onLine);
  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);
  if (!offline) return null;
  return (
    <div
      data-testid="offline-banner"
      className="fixed top-14 left-0 right-0 z-30 bg-destructive/95 text-destructive-foreground text-sm text-center py-2 px-4 flex items-center justify-center gap-2"
    >
      <WifiOff className="h-4 w-4" />
      Çevrimdışısınız. Fiziksel masa modu çevrimdışı çalışır, veriler cihazınıza kaydediliyor.
    </div>
  );
}
